import React, { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { ColumnContent } from './SortableList';
import classnames from 'classnames';
import { Tooltip } from '../Tooltip/Tooltip';

export function TableCell<T>({
  row,
  index,
  column,
  sortBy,
  rowLink,
  onRowClick,
  mutedColor,
}: {
  row: T;
  index: number;
  column: ColumnContent<T>;
  sortBy?: Extract<keyof T, string>;
  rowLink?: (data: T) => string;
  onRowClick?: (data: T, index: number) => void;
  mutedColor;
}): JSX.Element {
  function renderCell(): ReactNode | null | undefined {
    if (column.cellRenderer) {
      return column.cellRenderer(row, index);
    }
    if (row[column.dataKey] && typeof row[column.dataKey] === 'object') {
      // eslint-disable-next-line
      console.log(row[column.dataKey]);

      throw new Error(
        `table cell prop can't be an object: ${column.dataKey}. Use cellRenderer function to render objects.`
      );
    }
    if (column.dataKey === 'sku') {
      return <SKUCell sku={row['sku']} />;
    } else {
      return row[column.dataKey];
    }
  }

  const cell =
    !column.disableLink && rowLink ? <NavLink to={rowLink(row)}>{renderCell()}</NavLink> : <>{renderCell()}</>;

  const cellClassNames =
    (typeof column.cellClassNames === 'function' ? column.cellClassNames(row, index) : column.cellClassNames) || [];

  return (
    <td
      style={{
        width: column.width,
        maxWidth: column.maxWidth,
        textAlign: column.align,
      }}
      rowSpan={column.rowSpan?.(row, index)}
      className={classnames(...cellClassNames, 'sortable-list__cell', {
        'sortable-list__cell--sorted': sortBy && sortBy === column.dataKey,
        'sortable-list__cell--highlighted': column.highlight,
        'sortable-list__with-separator': column.separator,
        'ellipsis-overflow': column.ellipsisOverflow,
        'sortable-list__cell--muted': mutedColor,
      })}
      onClick={() => onRowClick?.(row, index)}
    >
      {column.tooltip !== undefined ? (
        <Tooltip reference={cell} className="sortable-list__tooltip" position={column.tooltip.position}>
          {column.tooltip.content}
        </Tooltip>
      ) : (
        cell
      )}
    </td>
  );
}

const SKUCell = ({ sku }: { sku: string }): JSX.Element | null => {
  return <div className="list-cell__sku">{sku}</div>;
};
